import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import List from "@mui/icons-material/List";
import ListAlt from "@mui/icons-material/ListAlt";
import FindInPage from "@mui/icons-material/FindInPage";
import DirectionsBoatOutlined from "@mui/icons-material/DirectionsBoatOutlined";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { API_Route_Favorite } from "../Shared/Urls.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { RouteModule_RouteSummary, RouteModule_RouteSummary_$reflection, GenericResponse_$reflection } from "../Shared/ApiDataTypes.js";
import { unwrap, map, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_Bind, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { cons, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { mapFetchError } from "../Promises.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { wrapTooltip, ErrorHandling_snackError } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Tab, Tabs, Skeleton, IconButton, Typography, Button } from "@mui/material";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { TableView } from "./RouteAuditLogs.js";
import { View } from "./RouteEventLog.js";
import { RouteEdit } from "./RouteAdmin.js";
import { RouteActivities } from "./RouteActivity.js";

class RouteNav extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Info", "Log", "Activities", "AuditLogs"];
    }
}

function RouteNav_$reflection() {
    return union_type("RouteMenuRoot.RouteNav", [], RouteNav, () => [[], [], [], []]);
}

function RouteNav__get_Url(this$) {
    switch (this$.tag) {
        case 1:
            return "log";
        case 2:
            return "activities";
        case 3:
            return "auditlogs";
        default:
            return "info";
    }
}

function RouteNav__get_Label(this$) {
    switch (this$.tag) {
        case 1:
            return "Log";
        case 2:
            return "Aktiviteter";
        case 3:
            return "Endringer";
        default:
            return "Detaljer";
    }
}

function RouteNav__get_Icon(this$) {
    switch (this$.tag) {
        case 1: {
            const props_3 = {};
            return react.createElement(List, props_3);
        }
        case 2: {
            const props_5 = {};
            return react.createElement(ListAlt, props_5);
        }
        case 3: {
            const props_7 = {};
            return react.createElement(FindInPage, props_7);
        }
        default: {
            const props_1 = {};
            return react.createElement(DirectionsBoatOutlined, props_1);
        }
    }
}

const routeNavItems = [new RouteNav(0, []), new RouteNav(2, []), new RouteNav(3, [])];

function favorite(routeId, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, body, decoder, data_1, caseStrategy_3, extra_3;
        const requestPath = API_Route_Favorite(routeId);
        return ((pr_1 = ((body = Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(""), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(Result_Bind((g) => {
                if (g.Result === "success") {
                    return new FSharpResult$2(0, [undefined]);
                }
                else {
                    return new FSharpResult$2(1, [g.Message]);
                }
            }, _arg_2));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function unFavorite(routeId, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = API_Route_Favorite(routeId);
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = "", (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(string_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(Result_Bind((g) => {
                if (g.Result === "success") {
                    return new FSharpResult$2(0, [undefined]);
                }
                else {
                    return new FSharpResult$2(1, [g.Message]);
                }
            }, _arg_2));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

export function RouteMenu(routeMenuInputProps) {
    let elems_4;
    const subsegment = routeMenuInputProps.subsegment;
    const routeId = routeMenuInputProps.routeId;
    const patternInput = reactApi.useState(undefined);
    const setRouteSummary = patternInput[1];
    const routeSummary = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    useEffectOnce(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr_1, decoder, data_1, caseStrategy_2, extra_2;
            return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(RouteModule_RouteSummary_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/route/${routeId}/summary`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(RouteModule_RouteSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))), pr_1.then(mapFetchError))).then((_arg_3) => {
                const res_1 = _arg_3;
                if (res_1.tag === 1) {
                    setError(res_1.fields[0]);
                    return Promise.resolve();
                }
                else {
                    setRouteSummary(res_1.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_2.then();
    });
    return createElement("div", createObj(singleton((elems_4 = toList(delay(() => append(singleton_1(ErrorHandling_snackError(patternInput_1[0], () => {
        setError(undefined);
    })), delay(() => {
        let elems_2;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 50 + "px ",
            padding: 16,
        }], (elems_2 = toList(delay(() => {
            let props_2;
            return append(singleton_1(MuiHelpers_createElement(Button, [["size", "large"], ["variant", "text"], ["component", "a"], ["href", RouterModule_encodeParts(singleton("routes"), 1)], ["startIcon", (props_2 = {}, react.createElement(ArrowBack, props_2))], ["children", "Alle samband"], ["style", {
                textTransform: "none",
                width: 150,
            }]])), delay(() => {
                const matchValue_1 = routeSummary;
                if (matchValue_1 != null) {
                    const v = matchValue_1;
                    return append(singleton_1(MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", v.Name]])), delay(() => {
                        let elems_1, elems;
                        return singleton_1(createElement("div", createObj(ofArray([["style", {
                            width: 150,
                            display: "flex",
                            justifyContent: "flex-end",
                        }], (elems_1 = [wrapTooltip(v.IsFavorite ? "Fjern fra \"Mine samband\"" : "Legg til i \"Mine samband\"", MuiHelpers_createElement(IconButton, [["style", {}], (elems = toList(delay(() => {
                            let props_8, props_10;
                            return v.IsFavorite ? singleton_1((props_8 = {}, react.createElement(Favorite, props_8))) : singleton_1((props_10 = {}, react.createElement(FavoriteBorder, props_10)));
                        })), ["children", reactApi.Children.toArray(Array.from(elems))]), ["onClick", (_arg_5) => {
                            const toggleOnSuccess = (_arg_6) => {
                                if (_arg_6.tag === 0) {
                                    setRouteSummary(new RouteModule_RouteSummary(v.Id, v.Name, !v.IsFavorite));
                                }
                                else {
                                    setError(_arg_6.fields[0]);
                                }
                            };
                            if (v.IsFavorite) {
                                unFavorite(routeId, toggleOnSuccess);
                            }
                            else {
                                favorite(routeId, toggleOnSuccess);
                            }
                        }]]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                    }));
                }
                else {
                    return append(singleton_1(MuiHelpers_createElement(Skeleton, [["width", 100], ["height", 48], ["variant", "text"]])), delay(() => singleton_1(MuiHelpers_createElement(Skeleton, [["width", 48], ["height", 48], ["variant", "circular"]]))));
                }
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elements;
            return append(singleton_1(MuiHelpers_createElement(Tabs, [["style", {
                marginBottom: 16,
            }], ["variant", "scrollable"], ["value", subsegment], ["textColor", "primary"], ["indicatorColor", "primary"], (elements = map_1((x_3) => {
                let segment2;
                return MuiHelpers_createElement(Tab, [["href", (segment2 = RouteNav__get_Url(x_3), RouterModule_encodeParts(ofArray(["routes", int32ToString(routeId), segment2]), 1))], ["component", "a"], ["label", RouteNav__get_Label(x_3)], ["value", RouteNav__get_Url(x_3)]]);
            }, routeNavItems), ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => {
                const onNameChanged = (s) => {
                    setRouteSummary(map((x_4) => (new RouteModule_RouteSummary(x_4.Id, s, x_4.IsFavorite)), routeSummary));
                };
                const matchValue_2 = subsegment;
                return (matchValue_2 === "auditlogs") ? singleton_1(createElement(TableView, {
                    routeId: routeId,
                })) : ((matchValue_2 === "log") ? singleton_1(createElement(View, {
                    routeId: routeId,
                })) : ((matchValue_2 === "info") ? singleton_1(createElement(RouteEdit, {
                    routeId: routeId,
                    onNameChanged: onNameChanged,
                })) : ((matchValue_2 === "activities") ? singleton_1(createElement(RouteActivities, {
                    routeId: routeId,
                })) : singleton_1(createElement(RouteEdit, {
                    routeId: routeId,
                    onNameChanged: onNameChanged,
                })))));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

//# sourceMappingURL=RouteMenuRoot.js.map
